import { actions as CUSTOMER_PORTAL_DATA } from "@src/Actions/Reducers/CustomerPortalDataReducer"
import history from "@src/browserHistory"
import { serverLog } from "@src/ControllerModules/Logging"
import { VIEW_PATHS } from "@src/Routes/constants"
import { axiosInstance } from "@src/Tools/AxiosInstance"
import * as _ from "lodash"
import { all, call, put, select, takeLeading } from "redux-saga/effects"

import * as PORTAL from "../../Actions/PortalActions"
import { IUpdateCustomerPortalData } from "../types"

function* getCustomerPortalData() {
  try {
    yield put(CUSTOMER_PORTAL_DATA.getCustomerPortalDataRequest())
    const { data } = yield axiosInstance.get(
      `/api/profile/getCustomerPortalData`,
    )
    if (data.success) {
      const isDashboard = data.data.introViewed?.dashboard
      const welcomeEmailSent = data.data?.welcomeEmailSent
      if (!isDashboard && welcomeEmailSent) {
        history.push(VIEW_PATHS["intro"])
      }
      yield put(CUSTOMER_PORTAL_DATA.getCustomerPortalDataSuccess(data.data))
    }
  } catch (e) {
    yield put(CUSTOMER_PORTAL_DATA.getCustomerPortalDataFailure(e))
  }
}

function* updateCustomerPortalData(action: IUpdateCustomerPortalData) {
  try {
    yield put(CUSTOMER_PORTAL_DATA.updateCustomerPortalDataRequest())
    const { data } = yield axiosInstance.post(
      `/api/profile/updateCustomerPortalData`,
      action.payload,
    )
    if (data.success) {
      yield put(CUSTOMER_PORTAL_DATA.updateCustomerPortalDataSuccess(data.data))
    }
  } catch (e) {
    yield put(CUSTOMER_PORTAL_DATA.updateCustomerPortalDataFailure(e))
  }
}

export function* updateDasboardSaga(): Generator<any, any, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `/api/dashboard/getModuleActivity`,
    )

    const state = yield select()
    const { compliance, insurance, training } = state.portal.dashboard

    if (!compliance && !insurance && !training) {
      yield put(PORTAL.setDashboardActivity({ status: "LOADING" }))
    }

    const isEqualData = _.isEqual(
      { compliance, insurance, training },
      data.data,
    )
    if (!isEqualData) {
      yield put(
        PORTAL.setDashboardActivity({ ...data.data, status: "SUCCESS" }),
      )
    }
  } catch {
    yield put(PORTAL.setDashboardActivity({ status: "FAILED" }))
    serverLog({
      level: "error",
      message: "Fetching Dashboard Activity Data failed",
      endpoint: "/dashboard/getModuleActivity",
      filename: __filename,
    })
  }
}

function* monitoringWatcherSaga() {
  yield all([
    takeLeading("UPDATE_DASHBOARD_WATCHER", updateDasboardSaga),
    takeLeading("GET_CUSTOMER_PORTAL_DATA_WATCHER", getCustomerPortalData),
    takeLeading(
      "UPDATE_CUSTOMER_PORTAL_DATA_WATCHER",
      updateCustomerPortalData,
    ),
  ])
}

export default monitoringWatcherSaga
